import "./Footer.css"

const Footer = () =>
{
    return(
        <footer className="footer">
            <div className="footer-container">

                <div className="footer-brand">
                    <h2>DeAndre Cook</h2>
                    <br/>
                    <p>Full Stack Software Engineer</p>
                </div>

                <div className="footer-services">
                    <h4>Services</h4>
                        <ul>
                            <li>Custom Web Applications</li>
                            <li>Backend & API Creation</li>
                            <li>Database Design</li>
                            <li>Consulting</li>
                        </ul>
                </div>
                <div className="footer-social">
                    <h4>Connect</h4>
                        <div className="social-icons">
                            <a href="https://www.linkedin.com/in/deandre-c-050a6311a/">LinkedIn</a>
                            <a href="https://github.com/deandrecook">GitHub</a>
                            <a href="mailto:drecook16@outlook.com">Email</a>
                        </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>© 2026 DeAndre Cook. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;